import { TrendingUp } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Card, CardHeader, CardTitle } from '@/components/ui/Card'
import { ProfitLine } from '@/features/cases/components/shared/ProfitLine'
import type { CaseMoney } from '@/types/domain'

/** «Прибыль» (S-11 revision): the case's one profit line (S-6) as a card of
 *  the overview, where the owner wanted the deal's headline number.
 *
 *  It holds `ProfitLine` unchanged — the served `profit` on its served basis,
 *  the plan beside it, «Как посчитано» shut by default — and adds nothing to
 *  it: no margin percentage, which the server does not serve and this client
 *  must not compute (AD-9). Mounted only for a reader the money block was
 *  served to; without it there is no card at all. */
export function ProfitCard({ money }: { money: CaseMoney }) {
  const { t } = useTranslation()

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <TrendingUp size={15} className="text-text-muted" aria-hidden />
          {t('cases.overview.profit')}
        </CardTitle>
      </CardHeader>
      {/* The card's title already says «Прибыль», so the line drops its own
          lead word; «Как посчитано» is its footer row. */}
      <ProfitLine money={money} headless />
    </Card>
  )
}
